import React, { useContext } from 'react';
import { AuthContext } from '../../context/authContext';
import Header from '../topbotm/Header';
import Footer from '../topbotm/Footer';
import Sidebar from './sidebar';
import '../css/dashboard/DashBoardM.css';
import DashBoardC from './content';



const DashBoardM = () => {
    const { user } = useContext(AuthContext);
    return (
        <div className="dashboard-page">
            <Header />
            <div className="dashboard-wrapper">
                <div className='d-none' style={{backgroundColor:"#4a127e"}}>
                 <Sidebar user={user} />
                </div>
                <DashBoardC/>
            </div>
            <Footer />
        </div>
    );
};

export default DashBoardM;